export default __webpack_public_path__ + "static/media/290.c74f8729.png";